"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const redux_1 = require("redux");
const UI_1 = require("~/components/UI");
const selectors_1 = require("~/store/user/selectors");
const controls_1 = require("~/components/common/controls");
const AddressEditWindow_1 = __importDefault(require("~/components/Account/AddressEditWindow"));
const utils_1 = require("~/utils/utils");
const types_1 = require("~/store/project/types");
const consts_1 = require("~/store/account/consts");
const assets_1 = require("~/assets");
const events_1 = require("~/utils/events");
const actions_1 = require("~/store/data/actions");
const selectors_2 = require("~/store/data/selectors");
const types_2 = require("~/store/loading/types");
const consts_2 = require("~/consts/consts");
const useProjectStatus_1 = __importDefault(require("~/hooks/useProjectStatus"));
const actions_2 = require("~/store/actions");
const routes_1 = require("~/consts/routes");
const react_router_dom_1 = require("react-router-dom");
const events_2 = require("~/consts/events");
const AddCustomerModal_1 = __importDefault(require("~/components/CustomersManagement/AddCustomerModal"));
const EditProjectForm_module_scss_1 = __importDefault(require("./EditProjectForm.module.scss"));
const isProjectStatusDisabled_1 = __importDefault(require("./isProjectStatusDisabled"));
const prospect = {
    id: 0,
    shippingAddresses: [],
    firstName: consts_2.PROSPECT,
    lastName: '',
};
const US_COUNTRY_ID = 230;
function EditProjectForm({ project, editableStatus, onChange, isNew, openedInEditMode, inQuoteWidget = false, }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const { t } = (0, react_i18next_1.useTranslation)('project');
    const user = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const currentUserRole = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUserRole);
    const distributors = (0, react_redux_1.useSelector)(selectors_2.selectDistributors);
    const userAddresses = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUserAddresses);
    const customers = (0, react_redux_1.useSelector)(selectors_2.selectConnectedCustomers);
    const isDataLoading = (0, react_redux_1.useSelector)(selectors_2.selectIsDataLoading);
    const [projectName, setProjectName] = (0, react_1.useState)('');
    const [currentDistributorId, setCurrentDistributorId] = (0, react_1.useState)((_a = project === null || project === void 0 ? void 0 : project.distributorId) !== null && _a !== void 0 ? _a : null);
    const [currentCustomerId, setCurrentCustomerId] = (0, react_1.useState)((_b = project === null || project === void 0 ? void 0 : project.customerId) !== null && _b !== void 0 ? _b : null);
    const [currentCustomerAddresses, setCurrentCustomerAddresses] = (0, react_1.useState)([]);
    const [currentAddressId, setCurrentAddressId] = (0, react_1.useState)((_c = project === null || project === void 0 ? void 0 : project.shippingAddressId) !== null && _c !== void 0 ? _c : null);
    const [status, setStatus] = (0, react_1.useState)((_d = project === null || project === void 0 ? void 0 : project.status) !== null && _d !== void 0 ? _d : types_1.PROJECT_STATUS.IN_PROGRESS);
    const [designerEmail, setDesignerEmail] = (0, react_1.useState)((_e = project === null || project === void 0 ? void 0 : project.designerEmail) !== null && _e !== void 0 ? _e : '');
    const [currentCountryId, setCurrentCountryId] = (0, react_1.useState)((_f = project === null || project === void 0 ? void 0 : project.countryId) !== null && _f !== void 0 ? _f : null);
    const [state, setState] = (0, react_1.useState)('');
    const [statesForCountry, setStatesForCountry] = (0, react_1.useState)([]);
    const states = (0, react_redux_1.useSelector)(selectors_2.selectStatesWithDistributors);
    const countries = (0, react_redux_1.useSelector)(selectors_2.selectCountriesiWithDistributors);
    const getCurrentState = () => {
        var _a;
        return statesForCountry.length > 0 && state !== ''
            ? (_a = statesForCountry.find((stateForCountry) => stateForCountry.name === state)) !== null && _a !== void 0 ? _a : null
            : null;
    };
    const { shared = false, isProspect = false } = project !== null && project !== void 0 ? project : {};
    const { isOrderCompleted, isProjectArchived, isProjectViewOnly } = (0, useProjectStatus_1.default)();
    const completedOrArchivedOrViewOnly = (isOrderCompleted || isProjectArchived || isProjectViewOnly) && !isNew;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const prefillDistributor = () => {
        var _a, _b, _c, _d;
        if (isNew) {
            const prefillDistributorByCustomersDistributor = () => {
                var _a, _b;
                if (user === null || user === void 0 ? void 0 : user.invitingDistributor) {
                    const stateName = (_a = user.invitingDistributor.publicAddress) === null || _a === void 0 ? void 0 : _a.state;
                    const countryId = (_b = user.invitingDistributor.publicAddress) === null || _b === void 0 ? void 0 : _b.country_id;
                    const distributorId = user.invitingDistributor.id;
                    if (stateName && countryId && distributorId) {
                        setState(stateName);
                        setCurrentCountryId(countryId);
                        setCurrentDistributorId(distributorId);
                    }
                }
            };
            if ((_a = user === null || user === void 0 ? void 0 : user.projects) === null || _a === void 0 ? void 0 : _a.length) {
                const lastProjectWithDistributor = user.projects
                    .filter((item) => { var _a, _b, _c, _d; return ((_b = (_a = item.distributor) === null || _a === void 0 ? void 0 : _a.publicAddress) === null || _b === void 0 ? void 0 : _b.state) && ((_d = (_c = item.distributor) === null || _c === void 0 ? void 0 : _c.publicAddress) === null || _d === void 0 ? void 0 : _d.country_id); })
                    .sort((a, b) => {
                    if (a.createdAt && b.createdAt) {
                        const dateA = new Date(a.createdAt);
                        const dateB = new Date(b.createdAt);
                        return dateB.getTime() - dateA.getTime();
                    }
                    return 0;
                })[0];
                if (lastProjectWithDistributor) {
                    const stateName = (_b = lastProjectWithDistributor.distributor) === null || _b === void 0 ? void 0 : _b.publicAddress.state;
                    const countryId = (_c = lastProjectWithDistributor.distributor) === null || _c === void 0 ? void 0 : _c.publicAddress.country_id;
                    const distributorId = (_d = lastProjectWithDistributor.distributor) === null || _d === void 0 ? void 0 : _d.id;
                    if (stateName && countryId && distributorId) {
                        setState(stateName);
                        setCurrentCountryId(countryId);
                        setCurrentDistributorId(distributorId);
                    }
                    else {
                        prefillDistributorByCustomersDistributor();
                    }
                }
                else {
                    prefillDistributorByCustomersDistributor();
                }
            }
            else {
                prefillDistributorByCustomersDistributor();
            }
        }
    };
    const isAdmin = currentUserRole === consts_1.UserRoles.admin;
    const isDistributor = currentUserRole === consts_1.UserRoles.distributor;
    const isCustomer = currentUserRole === consts_1.UserRoles.customer;
    const { dispatchFetchData, dispatchFetchCustomersConnectedToDistributor, dispatchValidateTokenAction } = (0, redux_1.bindActionCreators)({
        dispatchFetchData: actions_1.fetchData,
        dispatchFetchCustomersConnectedToDistributor: actions_1.fetchCustomersConnectedToDistributor,
        dispatchValidateTokenAction: actions_2.validateTokenAction,
    }, (0, react_redux_1.useDispatch)());
    (0, react_1.useEffect)(() => {
        const currentCountryStates = states === null || states === void 0 ? void 0 : states.filter((currentCountryState) => currentCountryState.countryId === currentCountryId);
        setStatesForCountry((currentCountryStates === null || currentCountryStates === void 0 ? void 0 : currentCountryStates.length) ? currentCountryStates : []);
    }, [currentCountryId, states]);
    (0, react_1.useEffect)(() => {
        var _a;
        if ((userAddresses === null || userAddresses === void 0 ? void 0 : userAddresses.length) && !currentAddressId && isCustomer) {
            setCurrentAddressId((_a = userAddresses[0]) === null || _a === void 0 ? void 0 : _a.id);
        }
    }, [userAddresses]);
    (0, react_1.useEffect)(() => {
        var _a;
        const currentCustomer = customers.find((customer) => customer.id === currentCustomerId);
        if (currentCustomer) {
            setCurrentCustomerAddresses((_a = currentCustomer.shippingAddresses) !== null && _a !== void 0 ? _a : []);
        }
    }, [customers]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (currentCustomerId === 0 || (isDistributor && ((_a = user === null || user === void 0 ? void 0 : user.distributor) === null || _a === void 0 ? void 0 : _a.isDirectAccount))) {
            const distributorId = currentUserRole === consts_1.UserRoles.distributor ? user === null || user === void 0 ? void 0 : user.distributorId : project === null || project === void 0 ? void 0 : project.distributorId;
            const currentDistributor = distributors.find((distributor) => distributor.id === distributorId);
            if (currentDistributor) {
                setCurrentCustomerAddresses([currentDistributor.publicAddress]);
                setCurrentAddressId(currentDistributor.publicAddress.id);
            }
        }
    }, [distributors]);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        setProjectName((_a = project === null || project === void 0 ? void 0 : project.name) !== null && _a !== void 0 ? _a : '');
        setCurrentDistributorId((_b = project === null || project === void 0 ? void 0 : project.distributorId) !== null && _b !== void 0 ? _b : null);
        setCurrentCustomerId(isProspect ? 0 : (_c = project === null || project === void 0 ? void 0 : project.customerId) !== null && _c !== void 0 ? _c : null);
        setStatus((_d = project === null || project === void 0 ? void 0 : project.status) !== null && _d !== void 0 ? _d : types_1.PROJECT_STATUS.IN_PROGRESS);
        if (currentCustomerId === 0 || (isDistributor && ((_e = user === null || user === void 0 ? void 0 : user.distributor) === null || _e === void 0 ? void 0 : _e.isDirectAccount))) {
            const distributorId = currentUserRole === consts_1.UserRoles.distributor ? user === null || user === void 0 ? void 0 : user.distributorId : project === null || project === void 0 ? void 0 : project.distributorId;
            const currentDistributor = distributors.find((distributor) => distributor.id === distributorId);
            if (currentDistributor) {
                setCurrentCustomerAddresses([currentDistributor.publicAddress]);
                setCurrentAddressId(currentDistributor.publicAddress.id);
            }
        }
        else {
            const currentCustomer = customers.find((customer) => customer.id === (project === null || project === void 0 ? void 0 : project.customerId));
            if (currentCustomer) {
                setCurrentCustomerAddresses((_f = currentCustomer.shippingAddresses) !== null && _f !== void 0 ? _f : []);
            }
            setCurrentAddressId((_g = project === null || project === void 0 ? void 0 : project.shippingAddressId) !== null && _g !== void 0 ? _g : null);
        }
        if ((user === null || user === void 0 ? void 0 : user.id) && (user === null || user === void 0 ? void 0 : user.roleId)) {
            dispatchFetchData(project === null || project === void 0 ? void 0 : project.distributorId);
        }
    }, [user === null || user === void 0 ? void 0 : user.distributorId, user === null || user === void 0 ? void 0 : user.id, user === null || user === void 0 ? void 0 : user.roleId, project]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (project) {
            setState((_b = (_a = states === null || states === void 0 ? void 0 : states.find((curr) => curr.id === (project === null || project === void 0 ? void 0 : project.stateId))) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '');
        }
    }, [states, project]);
    (0, react_1.useEffect)(() => {
        var _a;
        setCurrentCountryId((_a = project === null || project === void 0 ? void 0 : project.countryId) !== null && _a !== void 0 ? _a : (isNew ? US_COUNTRY_ID : null));
    }, [project, isNew]);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d;
        onChange({
            customerId: currentCustomerId || undefined,
            distributorId: currentDistributorId,
            id: (_a = project === null || project === void 0 ? void 0 : project.id) !== null && _a !== void 0 ? _a : 0,
            isProspect: currentCustomerId === 0,
            name: projectName,
            shippingAddressId: isDistributor && ((_b = user === null || user === void 0 ? void 0 : user.distributor) === null || _b === void 0 ? void 0 : _b.isDirectAccount)
                ? user.distributor.publicAddress.id
                : currentAddressId !== null && currentAddressId !== void 0 ? currentAddressId : null,
            status,
            designerEmail: designerEmail !== null && designerEmail !== void 0 ? designerEmail : undefined,
            completedBy: status === types_1.PROJECT_STATUS.ORDER_ENTERED ? currentUserRole : 'none',
            countryId: currentCountryId,
            stateId: (_d = (_c = getCurrentState()) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : null,
        });
    }, [
        projectName,
        currentCustomerId,
        currentDistributorId,
        currentAddressId,
        status,
        designerEmail,
        currentCountryId,
        state,
    ]);
    const showAddressEditWindow = () => (0, events_1.showModal)(react_1.default.createElement(AddressEditWindow_1.default, { cancelHandler: events_1.hideModal, submitHandler: events_1.hideModal, customer: customers.find((customer) => customer.id === currentCustomerId), distributorId: currentDistributorId !== null && currentDistributorId !== void 0 ? currentDistributorId : undefined }));
    const showAddCustomerWindow = () => {
        (0, events_1.showModal)(react_1.default.createElement(AddCustomerModal_1.default, { cancelHandler: events_1.hideModal, submitHandler: events_1.hideModal, distributorId: currentDistributorId !== null && currentDistributorId !== void 0 ? currentDistributorId : undefined }));
    };
    const onKeyDownHandler = (event) => {
        if (event.key === 'Enter' || event.key === 'Accept' || event.key === ' ') {
            showAddressEditWindow();
        }
    };
    const setCurrentCustomerHandler = (customerId) => {
        var _a;
        if (customerId !== currentCustomerId) {
            setCurrentCustomerId(customerId);
            if (customerId === 0) {
                const distributorId = currentUserRole === consts_1.UserRoles.distributor ? user === null || user === void 0 ? void 0 : user.distributorId : currentDistributorId;
                const currentDistributor = distributors.find((distributor) => distributor.id === distributorId);
                if (currentDistributor) {
                    setCurrentCustomerAddresses([currentDistributor.publicAddress]);
                    setCurrentAddressId(currentDistributor.publicAddress.id);
                }
            }
            else {
                const currentCustomer = customers.find((customer) => customer.id === customerId);
                if (currentCustomer) {
                    setCurrentCustomerAddresses((_a = currentCustomer.shippingAddresses) !== null && _a !== void 0 ? _a : []);
                }
                setCurrentAddressId(null);
            }
        }
    };
    const setCurrentDistributorHandler = (distributorId) => {
        if (distributorId) {
            dispatchFetchCustomersConnectedToDistributor(distributorId);
        }
        if (distributorId !== currentDistributorId) {
            setCurrentDistributorId(distributorId);
            setCurrentCustomerId(null);
            setCurrentAddressId(null);
        }
    };
    (0, react_1.useEffect)(() => {
        dispatchValidateTokenAction(() => {
            (0, events_1.hideModal)();
            return navigate(routes_1.ROUTE_LOGIN);
        });
        prefillDistributor();
    }, []);
    const changeCustomerShippingAddress = (event) => {
        var _a;
        const { addressId, userId } = event.detail;
        const currentCustomerShippingAddresses = (_a = customers.find((curr) => curr.id === userId)) === null || _a === void 0 ? void 0 : _a.shippingAddresses;
        setCurrentCustomerId(userId);
        setCurrentAddressId(addressId);
        setCurrentCustomerAddresses(currentCustomerShippingAddresses !== null && currentCustomerShippingAddresses !== void 0 ? currentCustomerShippingAddresses : []);
    };
    const changeCustomerId = (event) => {
        var _a, _b;
        const { customer } = event.detail;
        const customerId = customer.id;
        setCurrentCustomerId(customerId);
        setCurrentAddressId(null);
        setCurrentCustomerAddresses((_a = customer.shippingAddresses) !== null && _a !== void 0 ? _a : []);
        if (((_b = user === null || user === void 0 ? void 0 : user.userType) === null || _b === void 0 ? void 0 : _b.name) === consts_1.UserRoles.admin && currentDistributorId) {
            dispatchFetchCustomersConnectedToDistributor(currentDistributorId);
        }
    };
    (0, react_1.useEffect)(() => {
        document.body.addEventListener(events_2.customerShippingAddressChanged, changeCustomerShippingAddress);
        document.body.addEventListener(events_2.customerIdChanged, changeCustomerId);
        return () => {
            document.body.removeEventListener(events_2.customerShippingAddressChanged, changeCustomerShippingAddress);
            document.body.removeEventListener(events_2.customerIdChanged, changeCustomerId);
        };
    }, []);
    const getAdminOrDistributorShipToOptions = () => {
        var _a, _b;
        if (currentCustomerAddresses.length) {
            return currentCustomerAddresses.map((address) => {
                return {
                    key: address.id,
                    value: (0, utils_1.formatAddressForDropdown)(address),
                };
            });
        }
        if ((_a = project === null || project === void 0 ? void 0 : project.customer) === null || _a === void 0 ? void 0 : _a.shippingAddresses) {
            return (_b = project === null || project === void 0 ? void 0 : project.customer) === null || _b === void 0 ? void 0 : _b.shippingAddresses.map((address) => {
                return {
                    key: address.id,
                    value: (0, utils_1.formatAddressForDropdown)(address),
                };
            });
        }
        return [];
    };
    const countryFields = (react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default.country },
        react_1.default.createElement("div", { className: `${EditProjectForm_module_scss_1.default.section} ${EditProjectForm_module_scss_1.default['address-section']}` },
            react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default[consts_2.INPUT_NAME] }, t('country')),
            react_1.default.createElement(controls_1.FormDropdown, { inputKey: "country", "data-testid": "new-project-country-dropdown", state: {
                    value: currentCountryId
                        ? {
                            value: (_g = countries.find((country) => country.id === currentCountryId)) === null || _g === void 0 ? void 0 : _g.name,
                            key: currentCountryId,
                        }
                        : null,
                    error: '',
                }, options: countries
                    ? [...countries]
                        .sort((a, b) => a.order - b.order)
                        .map((country) => ({
                        key: country.id,
                        value: country.name,
                    }))
                    : [], onInput: (key, id) => {
                    setCurrentDistributorId(null);
                    setCurrentCountryId(id !== null ? Number(id) : null);
                }, onError: () => null, placeholder: t('country'), disabled: status !== types_1.PROJECT_STATUS.IN_PROGRESS || completedOrArchivedOrViewOnly })),
        react_1.default.createElement("div", { className: `${EditProjectForm_module_scss_1.default.section} ${EditProjectForm_module_scss_1.default['address-section']}` },
            react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default[consts_2.INPUT_NAME] }, t('state')),
            react_1.default.createElement(controls_1.FormDropdown, { inputKey: "state", "data-testid": "new-project-state-dropdown", state: {
                    error: '',
                    value: ((_h = getCurrentState()) === null || _h === void 0 ? void 0 : _h.id) ? { key: ((_j = getCurrentState()) === null || _j === void 0 ? void 0 : _j.id) || 0, value: state } : null,
                }, onInput: (key, id) => {
                    var _a, _b;
                    setCurrentDistributorId(null);
                    setState((_b = (_a = states === null || states === void 0 ? void 0 : states.find((st) => st.id === id)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '');
                }, onError: () => null, options: statesForCountry
                    ? statesForCountry.map((stateForCountry) => ({
                        key: stateForCountry.id,
                        value: stateForCountry.name,
                    }))
                    : [], placeholder: t('state'), required: true, disabled: currentCountryId === null || status !== types_1.PROJECT_STATUS.IN_PROGRESS || completedOrArchivedOrViewOnly }))));
    const addNewAddress = (react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default['add-new'] },
        react_1.default.createElement("button", { type: "button", onClick: showAddressEditWindow, onKeyDown: onKeyDownHandler },
            react_1.default.createElement("img", { src: assets_1.svgBasicAddNew, alt: "" }),
            t('edit-project-form.add-new-address'))));
    const addNewCustomer = (react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default['add-new'] },
        react_1.default.createElement("button", { type: "button", onClick: showAddCustomerWindow, onKeyDown: showAddCustomerWindow },
            react_1.default.createElement("img", { src: assets_1.svgBasicAddNew, alt: "" }),
            t('edit-project-form.add-new-customer'))));
    const adminFormFields = (react_1.default.createElement(react_1.default.Fragment, null,
        inQuoteWidget
            ? !(status !== types_1.PROJECT_STATUS.IN_PROGRESS || completedOrArchivedOrViewOnly) && countryFields
            : countryFields,
        react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default.section },
            react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default[consts_2.INPUT_NAME] }, t('distributor')),
            react_1.default.createElement(controls_1.FormDropdown, { inputKey: "", state: {
                    value: currentDistributorId
                        ? {
                            key: currentDistributorId,
                            value: (_k = distributors === null || distributors === void 0 ? void 0 : distributors.find((distributor) => distributor.id === currentDistributorId)) === null || _k === void 0 ? void 0 : _k.companyName,
                        }
                        : null,
                    error: '',
                }, onInput: (key, value) => setCurrentDistributorHandler(value), onError: () => null, options: distributors
                    ? distributors
                        .filter((el) => {
                        var _a;
                        return !el.isDirectAccount &&
                            ((_a = el.states) === null || _a === void 0 ? void 0 : _a.find((st) => {
                                return st.name === state || (st.name === consts_2.ALL_STATES_NAME && st.countryId === currentCountryId);
                            }));
                    })
                        .map((distributor) => {
                        return {
                            key: distributor.id,
                            value: distributor.companyName,
                        };
                    })
                    : [], placeholder: t('edit-project-form.placeholder.distributor'), required: true, disabled: shared || completedOrArchivedOrViewOnly })),
        !openedInEditMode ? (react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default.section },
            react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default[consts_2.INPUT_NAME] }, t('designer-email')),
            react_1.default.createElement(UI_1.Input, { value: (project === null || project === void 0 ? void 0 : project.designerEmail) || designerEmail, type: "email", onInput: (value) => {
                    setDesignerEmail(value);
                }, required: true, placeholder: t('designers-email'), disabled: !currentDistributorId || completedOrArchivedOrViewOnly }))) : null,
        react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default.section },
            react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default[consts_2.INPUT_NAME] }, t('customer')),
            react_1.default.createElement(controls_1.FormDropdown, { inputKey: "", state: {
                    value: currentCustomerId !== null
                        ? {
                            key: currentCustomerId,
                            value: (0, utils_1.formatCustomerForDropdown)([prospect, ...customers].find((customer) => (customer === null || customer === void 0 ? void 0 : customer.id) === currentCustomerId)),
                        }
                        : null,
                    error: '',
                }, onInput: (key, value) => setCurrentCustomerHandler(value), onError: () => null, options: [prospect, ...customers].map((customer) => {
                    return {
                        key: customer.id,
                        value: (0, utils_1.formatCustomerForDropdown)(customer),
                    };
                }), placeholder: t('edit-project-form.placeholder.customer'), required: true, disabled: ((!currentDistributorId || shared) && !isProspect) || completedOrArchivedOrViewOnly, headlineComponent: currentCustomerId ? react_1.default.createElement("span", null) : addNewCustomer })),
        react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default.section },
            react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default[consts_2.INPUT_NAME] }, t(consts_2.SHIP_TO_ADDRESS)),
            react_1.default.createElement(controls_1.FormDropdown, { inputKey: "", state: {
                    value: currentAddressId
                        ? {
                            key: currentAddressId,
                            value: (0, utils_1.formatAddressForDropdown)((_l = currentCustomerAddresses === null || currentCustomerAddresses === void 0 ? void 0 : currentCustomerAddresses.find((address) => address.id === currentAddressId)) !== null && _l !== void 0 ? _l : project === null || project === void 0 ? void 0 : project.shippingAddress),
                        }
                        : null,
                    error: '',
                }, onInput: (key, value) => setCurrentAddressId(value), onError: () => null, options: getAdminOrDistributorShipToOptions(), placeholder: t(consts_2.SHIP_TO_ADDRESS_PLACEHOLDER), required: true, disabled: !currentCustomerId || completedOrArchivedOrViewOnly, headlineComponent: currentAddressId ? react_1.default.createElement("span", null) : addNewAddress }))));
    const distributorFormFields = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default.section, hidden: (_m = user === null || user === void 0 ? void 0 : user.distributor) === null || _m === void 0 ? void 0 : _m.isDirectAccount },
            react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default[consts_2.INPUT_NAME] }, t('customer')),
            react_1.default.createElement(controls_1.FormDropdown, { inputKey: "", state: {
                    value: currentCustomerId !== null
                        ? {
                            key: currentCustomerId,
                            value: (0, utils_1.formatCustomerForDropdown)([prospect, ...customers].find((customer) => (customer === null || customer === void 0 ? void 0 : customer.id) === currentCustomerId)),
                        }
                        : null,
                    error: '',
                }, onInput: (key, value) => setCurrentCustomerHandler(value), onError: () => null, options: [prospect, ...customers].map((customer, idx) => {
                    var _a;
                    return {
                        key: (customer === null || customer === void 0 ? void 0 : customer.id) || idx,
                        value: (_a = (0, utils_1.formatCustomerForDropdown)(customer)) !== null && _a !== void 0 ? _a : '',
                    };
                }), placeholder: t('edit-project-form.placeholder.customer'), required: true, disabled: (shared && !isProspect) || completedOrArchivedOrViewOnly, headlineComponent: currentCustomerId ? react_1.default.createElement("span", null) : addNewCustomer })),
        react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default.section },
            react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default[consts_2.INPUT_NAME] }, t(consts_2.SHIP_TO_ADDRESS)),
            react_1.default.createElement(controls_1.FormDropdown, { inputKey: "", state: {
                    value: currentAddressId
                        ? {
                            key: currentAddressId,
                            value: (0, utils_1.formatAddressForDropdown)((_o = currentCustomerAddresses === null || currentCustomerAddresses === void 0 ? void 0 : currentCustomerAddresses.find((address) => address.id === currentAddressId)) !== null && _o !== void 0 ? _o : project === null || project === void 0 ? void 0 : project.shippingAddress),
                        }
                        : null,
                    error: '',
                }, onInput: (key, value) => setCurrentAddressId(value), onError: () => null, options: getAdminOrDistributorShipToOptions(), placeholder: t(consts_2.SHIP_TO_ADDRESS_PLACEHOLDER), required: true, disabled: !currentCustomerId || completedOrArchivedOrViewOnly, headlineComponent: currentAddressId ? react_1.default.createElement("span", null) : addNewAddress }))));
    const customerFormFields = (react_1.default.createElement(react_1.default.Fragment, null,
        inQuoteWidget
            ? !(status !== types_1.PROJECT_STATUS.IN_PROGRESS || completedOrArchivedOrViewOnly) && countryFields
            : countryFields,
        react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default.section },
            react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default[consts_2.INPUT_NAME] }, t('distributor')),
            react_1.default.createElement(controls_1.FormDropdown, { "data-testid": "new-project-distributor-dropdown", inputKey: "", state: {
                    value: currentDistributorId
                        ? {
                            key: currentDistributorId,
                            value: (_p = distributors === null || distributors === void 0 ? void 0 : distributors.find((distributor) => distributor.id === currentDistributorId)) === null || _p === void 0 ? void 0 : _p.companyName,
                        }
                        : null,
                    error: '',
                }, onInput: (key, value) => setCurrentDistributorId(value), onError: () => null, options: distributors
                    ? distributors
                        .filter((el) => {
                        var _a;
                        return !el.isDirectAccount &&
                            ((_a = el.states) === null || _a === void 0 ? void 0 : _a.find((st) => {
                                return st.name === state || (st.name === consts_2.ALL_STATES_NAME && st.countryId === currentCountryId);
                            }));
                    })
                        .map((distributor) => {
                        return {
                            key: distributor.id,
                            value: distributor.companyName,
                        };
                    })
                    : [], placeholder: t('edit-project-form.placeholder.distributor'), required: true, disabled: status !== types_1.PROJECT_STATUS.IN_PROGRESS ||
                    completedOrArchivedOrViewOnly ||
                    currentCountryId === null ||
                    !state })),
        react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default.section },
            react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default[consts_2.INPUT_NAME] }, t(consts_2.SHIP_TO_ADDRESS)),
            react_1.default.createElement(controls_1.FormDropdown, { "data-testid": "new-project-address-dropdown", inputKey: "", state: {
                    value: currentAddressId
                        ? {
                            key: currentAddressId,
                            value: (0, utils_1.formatAddressForDropdown)(userAddresses === null || userAddresses === void 0 ? void 0 : userAddresses.find((address) => address.id === currentAddressId)),
                        }
                        : null,
                    error: '',
                }, onInput: (key, value) => setCurrentAddressId(value), onError: () => null, options: userAddresses
                    ? userAddresses.map((address) => {
                        return {
                            key: address.id,
                            value: (0, utils_1.formatAddressForDropdown)(address),
                        };
                    })
                    : [], placeholder: t(consts_2.SHIP_TO_ADDRESS_PLACEHOLDER), required: true, headlineComponent: currentAddressId ? react_1.default.createElement("span", null) : addNewAddress, disabled: completedOrArchivedOrViewOnly }))));
    const getFormFields = () => {
        if (isDistributor) {
            return distributorFormFields;
        }
        if (isAdmin) {
            return adminFormFields;
        }
        return customerFormFields;
    };
    return isDataLoading === types_2.LOADING_STATE.COMPLETE ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default.section },
            react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default[consts_2.INPUT_NAME] }, t('project-name')),
            react_1.default.createElement(UI_1.Input, { "data-testid": "new-project-name-input", required: true, onInput: (value) => setProjectName(value), placeholder: t('edit-project-form.placeholder.project-name'), maxLength: 60, value: projectName, disabled: completedOrArchivedOrViewOnly })),
        getFormFields(),
        editableStatus ? (react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default.section },
            react_1.default.createElement("div", { className: EditProjectForm_module_scss_1.default[consts_2.INPUT_NAME] }, t('status')),
            Object.values(types_1.PROJECT_STATUS).map((projectStatus) => {
                return (react_1.default.createElement("span", { className: EditProjectForm_module_scss_1.default.status, "data-selected": projectStatus === status, onClick: () => setStatus(projectStatus), key: projectStatus, "data-disabled": (0, isProjectStatusDisabled_1.default)(projectStatus, shared, isCustomer, isDistributor, project) }, projectStatus));
            }))) : null)) : (react_1.default.createElement("div", null, "Loading..."));
}
exports.default = EditProjectForm;
